@use '@/styles/tokens' as *;

// Figma node 219:327388 — a 2×2 grid of label/value pairs under a heading.

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding: var(--space-5);
  border: 1px solid var(--border-subtle);
  border-radius: $radius-xl;
  background: var(--surface-card);
}

.title {
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-20;
  font-weight: $font-weight-medium;
  line-height: 1.2;
  color: var(--text-primary);
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-5) var(--space-4);
  margin: 0;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.label {
  font-size: $font-size-13;
  line-height: 1.3;
  color: var(--text-muted);
}

.value {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: $font-size-16;
  line-height: 1.3;
  color: var(--text-primary);
}

.valueDanger {
  composes: value;
  color: $color-error-700;
}

.shield {
  flex: none;
  color: $color-brand-700;
}
